import $ from 'jquery';

String.prototype.validateEmail = function() {
    return this.match(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/) !== null;
};

String.prototype.ellipsify = function(maxLength) {
    var ret = this;

    if (this.length > maxLength) ret = ret.substr(0, maxLength - 3) + "...";

    return ret;
};

if (!String.prototype.startsWith) {
    // IE hack
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

if (console && !console.trace) {
    console.trace = function() {
        console.log('CALL STACK');
        console.log(new Error().stack);
    };
}

(function() {
    "use strict";

    /**
     * API invocation
     */
    function _invoke(path, d, c) {
        d = d ? d : {};

        $.ajax({
            cache: false,
            url: path,
            type: "GET",
            dataType: "json",
            data: d,
            success: function(r, s, x) {
                if (c) {
                    c(r);
                }
            },
            error: function(x, s, e) {
                if (c) {
                    c({
                        success: false,
                        message: e
                    });
                }
            }
        });
    }

    window.COLDCREEK = window.COLDCREEK || {};

    COLDCREEK.api = {
    };

    COLDCREEK.google = {
        trackOutbound: function(e) {
            // bail if no google analytics
            if (typeof ga === "undefined") { return; }

            var who = e.currentTarget;

            if ((who.hostname && who.hostname !== '#' && who.hostname !== window.location.hostname && who.hostname !== 'wordpress.org') || "mailto:" === who.protocol) {
                ga('send', 'event', {
                    'eventCategory': 'Outbound Link',
                    'eventAction': 'click',
                    'eventLabel': who.href,
                    'eventValue': 1,
                    'transport': 'beacon'
                });
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./assets/js/api.js